import { Select } from "@chakra-ui/react";
import styled from "styled-components";

export const PropostasPerdidasContainer = styled.div`
  margin-top: 15px;
  font-family: Akrobat SemiBold;
  background-color: #f9fbfb;
`;
export const PropostasPerdidasContainerText = styled.div`
  background-color: #ff0000;
  padding: 15px 0;
  h1 {
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
  }
`;
export const ContentLoading = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 99999;
  background-color: #ffffff;
`;
export const ContentLoadingContent = styled.div`
  width: 100px;
  height: 100px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  top: 20%;
  background-color: #fff;
`;
export const ContentFilterSelectVendedor = styled.div`
  width: 200px;
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
`;
export const SelectBox = styled(Select)`
  font-family: Akrobat SemiBold;
  box-shadow: none !important;
`;
export const ButtonFilter = styled.button`
  background-color: #ff0000;
  color: #fff;
  width: 6rem;
  border: none;
  border-radius: 5px;
  padding: 0 13px;
`;
export const ContentFilter = styled.div`
  display: flex;
  font-family: Akrobat SemiBold;
  justify-content: center;
  background-color: #f0f4f5;
  padding: 20px 0;
  color: #ff0000;
`;
export const ContentFilterSelect = styled.div`
  background-color: #fff;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  padding: 0 10px;
  font-size: 13px;
  margin: 0 10px;
  display: flex;
  align-items: center;

  input {
    border: 0;
    color: #919aae;
  }
`;
export const ButtonSelect = styled.button`
  background-color: #ff0000;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-family: "Akrobat";

  padding: 0 13px;
  height: 50px;
  width: 6rem;
`;
export const TablesGrid = styled.div`
  flex-direction: column;
  font-family: "Akrobat";
  margin-top: 15px;
`;
export const TablesHighlights = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
`;
export const TablesHighlightsItem = styled.div`
  background-color: #ff0000;
  color: #fff;
  width: 25%;
  height: 60px;
  margin-right: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
  border-radius: 5px;
`;
export const TablesHighlightsItemName = styled.p`
  font-size: 20px;
  font-weight: 300;
  strong {
    letter-spacing: 0.08rem;
  }
`;
export const ContentTables = styled.div`
  min-height: 50vh;

  thead {
    th {
      padding: 10px 20px;
      color: #ff0000;
      font-size: 14px;
      font-weight: 400;
    }
  }

  tbody {
    tr {
      background-color: #f6f6f6;
      td {
        padding: 0 20px;
        text-align: center;
        font-size: 14px;
        height: 30px;
      }
    }
  }
`;
export const ContentTablesHighlights = styled.div`
  display: flex;
  justify-content: center;
  font-family: "Roboto";
  margin: 40px 0;
`;
export const ContentTablesItem = styled.div`
  background-color: #63cf63;
  color: #fff;
  width: 25%;
  height: 60px;
  margin-right: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: "Akrobat";
  padding: 0 20px;
  border-radius: 5px;
`;
export const ContentTablesName = styled.p`
  font-size: 20px;
  font-weight: 300;
`;